import { render } from "./CvcOnlySessionForm.vue?vue&type=template&id=845dbdec&scoped=true&lang=pug"
import script from "./CvcOnlySessionForm.vue?vue&type=script&lang=ts"
export * from "./CvcOnlySessionForm.vue?vue&type=script&lang=ts"

import "./CvcOnlySessionForm.vue?vue&type=style&index=0&id=845dbdec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-845dbdec"

export default script